import { Map, Placemark, YMaps } from '@pbe/react-yandex-maps';
import { Layout } from 'components/layout';
import { cn } from 'lib/utils';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import React, { useLayoutEffect, useState } from 'react';
import { Checkbox } from '../primitives/checkbox/checkbox'; // Импорт из shadcn

// Тип для объекта точки
interface Location {
  id: number;
  coordinates: [number, number];
  title: string;
  category: keyof Filters;
  distance: string;
  time: string;
}

// Тип для фильтров
interface Filters {
  all: boolean;
  cafe_restaurant: boolean;
  pharmacy: boolean;
  shop: boolean;
  school: boolean;
  kindergarten: boolean;
  med: boolean;
  culture: boolean;
  zoo: boolean;
  post: boolean;
  pickup: boolean;
  entertainment: boolean;
  sport: boolean;
  finance: boolean;
  government: boolean;
}

const filterToCategoryMap: Record<keyof Filters, string> = {
  all: "Все",
  cafe_restaurant: "Кафе и рестораны",
  pharmacy: "Аптека",
  shop: "Магазины",
  school: "Школа",
  kindergarten: "Детский сад",
  zoo: "Зоомагазины",
  med: "Больницы",
  culture: "Культурный объект",
  post: "Почта",
  pickup: "ПВЗ",
  entertainment: "Развлечения",
  sport: "Спорт",
  finance: "Финансы",
  government: "Государственные учреждения"
};

// Тип для подсчёта количества точек по категориям
interface FilterCounts {
  all: number;
  cafe_restaurant: number;
  pharmacy: number;
  shop: number;
  school: number;
  kindergarten: number;
  med: number;
  culture: number;
  post: number;
  pickup: number;
  entertainment: number;
  sport: number;
  finance: number;
  government: number;
};

// Данные точек
const locations: Location[] = [
  {
    "id": 1,
    "coordinates": [
      55.594184,
      37.106359
    ],
    "title": "МФЦ",
    "category": "government",
    "distance": "0,37 км",
    "time": "4 м"
  },
  {
    "id": 2,
    "coordinates": [
      55.59466,
      37.107034
    ],
    "title": "Школа № 2057, дошкольное отделение № 2",
    "category": "school",
    "distance": "0,25 км",
    "time": "2,5 м"
  },
  {
    "id": 3,
    "coordinates": [
      55.595568,
      37.107456
    ],
    "title": "Усадьба Крекшино",
    "category": "culture",
    "distance": "0,12 км",
    "time": "1 м"
  },
  {
    "id": 4,
    "coordinates": [
      55.596133,
      37.108786
    ],
    "title": "Отделение почтовой связи № 108810",
    "category": "post",
    "distance": "0,11 км",
    "time": "1 м"
  },
  {
    "id": 5,
    "coordinates": [
      55.596133,
      37.108786
    ],
    "title": "СМП банк",
    "category": "finance",
    "distance": "0,11 км",
    "time": "1 м"
  },
  {
    "id": 6,
    "coordinates": [
      55.596133,
      37.108786
    ],
    "title": "Почта Банк",
    "category": "finance",
    "distance": "0,11 км",
    "time": "1 м"
  },
  {
    "id": 7,
    "coordinates": [
      55.595984,
      37.107248
    ],
    "title": "Wildberries",
    "category": "pickup",
    "distance": "0,05 км",
    "time": "0,5 м"
  },
  {
    "id": 8,
    "coordinates": [
      55.595984,
      37.107248
    ],
    "title": "Ozon",
    "category": "pickup",
    "distance": "0,05 км",
    "time": "0,5 м"
  },
  {
    "id": 9,
    "coordinates": [
      55.596546,
      37.113227
    ],
    "title": "Ресторан Крекшино Парк",
    "category": "cafe_restaurant",
    "distance": "0,3 км",
    "time": "3 м"
  },
  {
    "id": 10,
    "coordinates": [
      55.596824,
      37.114076
    ],
    "title": "Пиццерия Пицца на дровах",
    "category": "cafe_restaurant",
    "distance": "0,29 км",
    "time": "3 м"
  },
  {
    "id": 11,
    "coordinates": [
      55.596824,
      37.114076
    ],
    "title": "Ярмарка Крекшино",
    "category": "shop",
    "distance": "0,29 км",
    "time": "3 м"
  },
  {
    "id": 12,
    "coordinates": [
      55.596824,
      37.114076
    ],
    "title": "Магазин продуктов",
    "category": "shop",
    "distance": "0,29 км",
    "time": "3 м"
  },
  {
    "id": 13,
    "coordinates": [
      55.596824,
      37.114076
    ],
    "title": "Магазин бытовой техники",
    "category": "shop",
    "distance": "0,29 км",
    "time": "3 м"
  },
  {
    "id": 14,
    "coordinates": [
      55.596824,
      37.114076
    ],
    "title": "Магазин Икорный",
    "category": "shop",
    "distance": "0,29 км",
    "time": "3 м"
  },
  {
    "id": 15,
    "coordinates": [
      55.596824,
      37.114076
    ],
    "title": "Товары для дома Simply Lovely",
    "category": "shop",
    "distance": "0,29 км",
    "time": "3 м"
  },
  {
    "id": 16,
    "coordinates": [
      55.596824,
      37.114076
    ],
    "title": "Кавина (алкогольные напитки)",
    "category": "shop",
    "distance": "0,29 км",
    "time": "3 м"
  },
  {
    "id": 17,
    "coordinates": [
      55.596824,
      37.114076
    ],
    "title": "Пиво",
    "category": "shop",
    "distance": "0,29 км",
    "time": "3 м"
  },
  {
    "id": 18,
    "coordinates": [
      55.596824,
      37.114076
    ],
    "title": "ВкусВилл",
    "category": "shop",
    "distance": "0,29 км",
    "time": "3 м"
  },
  {
    "id": 19,
    "coordinates": [
      55.596824,
      37.114076
    ],
    "title": "Каравай-СВ",
    "category": "shop",
    "distance": "0,29 км",
    "time": "3 м"
  },
  {
    "id": 20,
    "coordinates": [
      55.596824,
      37.114076
    ],
    "title": "Народный кондитер",
    "category": "shop",
    "distance": "0,29 км",
    "time": "3 м"
  },
  {
    "id": 21,
    "coordinates": [
      55.596824,
      37.114076
    ],
    "title": "Ешь еду",
    "category": "shop",
    "distance": "0,29 км",
    "time": "3 м"
  },
  {
    "id": 22,
    "coordinates": [
      55.596824,
      37.114076
    ],
    "title": "Овощи и фрукты",
    "category": "shop",
    "distance": "0,29 км",
    "time": "3 м"
  },
  {
    "id": 23,
    "coordinates": [
      55.596824,
      37.114076
    ],
    "title": "Flower basket",
    "category": "shop",
    "distance": "0,29 км",
    "time": "3 м"
  },
  {
    "id": 24,
    "coordinates": [
      55.596824,
      37.114076
    ],
    "title": "Мясо",
    "category": "shop",
    "distance": "0,29 км",
    "time": "3 м"
  },
  {
    "id": 25,
    "coordinates": [
      55.596824,
      37.114076
    ],
    "title": "Яйцо, птица",
    "category": "shop",
    "distance": "0,29 км",
    "time": "3 м"
  },
  {
    "id": 26,
    "coordinates": [
      55.596824,
      37.114076
    ],
    "title": "Havana Smoke",
    "category": "shop",
    "distance": "0,29 км",
    "time": "3 м"
  },
  {
    "id": 27,
    "coordinates": [
      55.596824,
      37.114076
    ],
    "title": "Рыба",
    "category": "shop",
    "distance": "0,29 км",
    "time": "3 м"
  },
  {
    "id": 28,
    "coordinates": [
      55.596824,
      37.114076
    ],
    "title": "Прасковья Тулупова",
    "category": "shop",
    "distance": "0,29 км",
    "time": "3 м"
  },
  {
    "id": 29,
    "coordinates": [
      55.596824,
      37.114076
    ],
    "title": "Рузское молоко",
    "category": "shop",
    "distance": "0,29 км",
    "time": "3 м"
  },
  {
    "id": 30,
    "coordinates": [
      55.596824,
      37.114076
    ],
    "title": "Книжный лабиринт",
    "category": "shop",
    "distance": "0,29 км",
    "time": "3 м"
  },
  {
    "id": 31,
    "coordinates": [
      55.596824,
      37.114076
    ],
    "title": "ЗооЛавка",
    "category": "shop",
    "distance": "0,29 км",
    "time": "3 м"
  },
  {
    "id": 32,
    "coordinates": [
      55.596824,
      37.114076
    ],
    "title": "Big Green Egg",
    "category": "shop",
    "distance": "0,29 км",
    "time": "3 м"
  },
  {
    "id": 33,
    "coordinates": [
      55.596824,
      37.114076
    ],
    "title": "Аптека.ру",
    "category": "pharmacy",
    "distance": "0,29 км",
    "time": "3 м"
  },
  {
    "id": 34,
    "coordinates": [
      55.596824,
      37.114076
    ],
    "title": "Ozon",
    "category": "pickup",
    "distance": "0,29 км",
    "time": "3 м"
  },
  {
    "id": 35,
    "coordinates": [
      55.596824,
      37.114076
    ],
    "title": "Л-Пост",
    "category": "pickup",
    "distance": "0,29 км",
    "time": "3 м"
  },
  {
    "id": 36,
    "coordinates": [
      55.596824,
      37.114076
    ],
    "title": "Лабиринт",
    "category": "pickup",
    "distance": "0,29 км",
    "time": "3 м"
  },
  {
    "id": 37,
    "coordinates": [
      55.596824,
      37.114076
    ],
    "title": "Сбербанк",
    "category": "finance",
    "distance": "0,29 км",
    "time": "3 м"
  },
  {
    "id": 38,
    "coordinates": [
      55.596824,
      37.114076
    ],
    "title": "IIIy",
    "category": "cafe_restaurant",
    "distance": "0,29 км",
    "time": "3 м"
  },
  {
    "id": 39,
    "coordinates": [
      55.596824,
      37.114076
    ],
    "title": "Банк Открытие",
    "category": "finance",
    "distance": "0,29 км",
    "time": "3 м"
  },
  {
    "id": 40,
    "coordinates": [
      55.596824,
      37.114076
    ],
    "title": "Совкомбанк",
    "category": "finance",
    "distance": "0,29 км",
    "time": "3 м"
  },
  {
    "id": 41,
    "coordinates": [
      55.596237,
      37.114352
    ],
    "title": "Крекшино",
    "category": "shop",
    "distance": "0,25 км",
    "time": "2,5 м"
  },
  {
    "id": 42,
    "coordinates": [
      55.596237,
      37.114352
    ],
    "title": "М.С.-Мед",
    "category": "pharmacy",
    "distance": "0,25 км",
    "time": "2,5 м"
  },
  {
    "id": 43,
    "coordinates": [
      55.596237,
      37.114352
    ],
    "title": "Дикси",
    "category": "shop",
    "distance": "0,25 км",
    "time": "2,5 м"
  },
  {
    "id": 44,
    "coordinates": [
      55.596237,
      37.114352
    ],
    "title": "Зверюка",
    "category": "zoo",
    "distance": "0,25 км",
    "time": "2,5 м"
  },
  {
    "id": 45,
    "coordinates": [
      55.596237,
      37.114352
    ],
    "title": "Сбербанк",
    "category": "finance",
    "distance": "0,25 км",
    "time": "2,5 м"
  },
  {
    "id": 46,
    "coordinates": [
      55.595672,
      37.114518
    ],
    "title": "Пятерочка",
    "category": "shop",
    "distance": "0,41 км",
    "time": "4 м"
  },
  {
    "id": 47,
    "coordinates": [
      55.595672,
      37.114518
    ],
    "title": "Ozon",
    "category": "pickup",
    "distance": "0,41 км",
    "time": "4 м"
  },
  {
    "id": 48,
    "coordinates": [
      55.595672,
      37.114518
    ],
    "title": "5 Post",
    "category": "pickup",
    "distance": "0,41 км",
    "time": "4 м"
  },
  {
    "id": 49,
    "coordinates": [
      55.595672,
      37.114518
    ],
    "title": "Тинькофф",
    "category": "finance",
    "distance": "0,41 км",
    "time": "4 м"
  },
  {
    "id": 50,
    "coordinates": [
      55.594993,
      37.113133
    ],
    "title": "Party Wake Крекшино",
    "category": "entertainment",
    "distance": "0,36 км",
    "time": "3 м"
  },
  {
    "id": 51,
    "coordinates": [
      55.596513,
      37.113294
    ],
    "title": "Крекшино Парк",
    "category": "entertainment",
    "distance": "0,23 км",
    "time": "2 м"
  },
  {
    "id": 52,
    "coordinates": [
      55.594471,
      37.111384
    ],
    "title": "Парк им. Льва Толстого",
    "category": "entertainment",
    "distance": "0,06 км",
    "time": "1 м"
  },
  {
    "id": 53,
    "coordinates": [
      55.593559,
      37.10751
    ],
    "title": "ГБУЗ г. Москвы Гор. больница г. Московский ДЗМ, филиал № 2",
    "category": "med",
    "distance": "0,35 км",
    "time": "3,5 м"
  },
  {
    "id": 54,
    "coordinates": [
      55.593559,
      37.10751
    ],
    "title": "Ммкц Коммунарка, Женская консультация № 13",
    "category": "med",
    "distance": "0,35 км",
    "time": "3,5 м"
  },
  {
    "id": 55,
    "coordinates": [
      55.596218,
      37.10768
    ],
    "title": "Маяк",
    "category": "entertainment",
    "distance": "0,09 км",
    "time": "1 м"
  },
  {
    "id": 56,
    "coordinates": [
      55.592357,
      37.10198
    ],
    "title": "Премьерский лицей",
    "category": "school",
    "distance": "1 км",
    "time": "10 м"
  },
  {
    "id": 57,
    "coordinates": [
      55.593781,
      37.105394
    ],
    "title": "Школа № 2057",
    "category": "school",
    "distance": "0,5 км",
    "time": "5 м"
  },
  {
    "id": 58,
    "coordinates": [
      55.588338,
      37.08462
    ],
    "title": "Monte resort",
    "category": "entertainment",
    "distance": "2,1 км",
    "time": "20 м"
  },
  {
    "id": 59,
    "coordinates": [
      55.588338,
      37.08462
    ],
    "title": "Конная усадьба",
    "category": "sport",
    "distance": "2,1 км",
    "time": "20 м"
  },
  {
    "id": 60,
    "coordinates": [
      55.624798,
      37.144065
    ],
    "title": "Metro",
    "category": "shop",
    "distance": "8,4 км",
    "time": "8 м"
  },
  {
    "id": 61,
    "coordinates": [
      55.620821,
      37.156457
    ],
    "title": "Православная гимназия Святителя Василия Великого",
    "category": "school",
    "distance": "6,6 км",
    "time": "6,5 м"
  },
  {
    "id": 62,
    "coordinates": [
      55.620821,
      37.156457
    ],
    "title": "Васильки",
    "category": "kindergarten",
    "distance": "6,6 км",
    "time": "6,5 м"
  },
  {
    "id": 63,
    "coordinates": [
      55.619026,
      37.153776
    ],
    "title": "Московская экономическая школа",
    "category": "school",
    "distance": "6,7 км",
    "time": "7 м"
  },
  {
    "id": 64,
    "coordinates": [
      55.619406,
      37.145341
    ],
    "title": "Меркурий",
    "category": "sport",
    "distance": "6,3 км",
    "time": "6 м"
  },
  {
    "id": 65,
    "coordinates": [
      55.601246,
      37.044725
    ],
    "title": "Звездный",
    "category": "shop",
    "distance": "7,1 км",
    "time": "7 м"
  },
  {
    "id": 66,
    "coordinates": [
      55.601246,
      37.044725
    ],
    "title": "Монитор",
    "category": "entertainment",
    "distance": "7,1 км",
    "time": "7 м"
  },
  {
    "id": 67,
    "coordinates": [
      55.602088,
      37.166331
    ],
    "title": "Сбербанк Доп.офис №9038/01822",
    "category": "finance",
    "distance": "4,2 км",
    "time": "4 м"
  },
  {
    "id": 68,
    "coordinates": [
      55.604093,
      37.168841
    ],
    "title": "ГБУЗ ГБ г. Московский ДЗМ, филиал № 6",
    "category": "med",
    "distance": "4,4 км",
    "time": "4 м"
  },
  {
    "id": 69,
    "coordinates": [
      55.595662,
      37.156556
    ],
    "title": "Инферно",
    "category": "entertainment",
    "distance": "7 км",
    "time": "7 м"
  },
  {
    "id": 70,
    "coordinates": [
      55.594843,
      37.038992
    ],
    "title": "Fitnesson",
    "category": "sport",
    "distance": "8,4 км",
    "time": "8 м"
  }
];

const initial: Filters = {
  all: true,
  culture: true,
  entertainment: true,
  finance: true,
  government: true,
  pickup: true,
  post: true,
  sport: true,
  cafe_restaurant: true,
  pharmacy: true,
  shop: true,
  school: true,
  kindergarten: true,
  med: true,
  zoo: true
}

Object.freeze(initial);

const MOBILE_BREAKPOINT = 768;

// Компонент карты с фильтрами
const YandexMapWithFilters: React.FC = () => {
  const [isMobile, setIsMobile] = useState<boolean>(false);
  const [isSidebarOpen, setIsSidebarOpen] = useState<boolean>(true);
  const [filters, setFilters] = useState<Filters>(initial);

  // Подсчёт количества точек по категориям
  const filterCounts: Partial<FilterCounts> = {};

  Object.keys(filters).forEach(el => {

    filterCounts["all"] = locations.length + 1; // Все точки плюс ЖК отдельно

    filterCounts[el as keyof FilterCounts] = locations.filter(
      (loc) => loc.category === el
    ).length
  })


  // Фильтрованные точки
  const filteredLocations: Location[] = locations.filter((location) => {
    if (filters.all) return true;
    return (
      (filters[location.category as keyof FilterCounts] && Object.keys(filters).includes(location.category))
    );
  });

  // Обработчик изменения чекбокса
  const handleFilterChange = (filterKey: keyof Filters) => {
    if (filterKey === 'all') {
      if (!filters.all) {
        setFilters(() => (initial));
      } else {
        setFilters(() => {
          const res = { ...initial };
          for (const key in res) {
            res[key as keyof Filters] = false;
          }
          return res;
        });
      }
    } else {
      setFilters((prev) => ({
        ...prev,
        [filterKey]: !prev[filterKey],
        all: false, // Снимаем галочку с "Все", если выбираем отдельный фильтр
      }));
    }
  };


  useLayoutEffect(() => {
    const mql = window.matchMedia(`(max-width: ${MOBILE_BREAKPOINT - 1}px)`);

    const onChange = () => {
      setIsMobile(window.innerWidth < MOBILE_BREAKPOINT);
    };

    mql.addEventListener("change", onChange);

    const isMobile = window.innerWidth < MOBILE_BREAKPOINT
    setIsMobile(isMobile);
    setIsSidebarOpen(!isMobile);
    return () => {
      mql.removeEventListener("change", onChange);
    };
  }, [MOBILE_BREAKPOINT]);

  // Точки для маршрута (как на скриншоте)
  // const routePoints: [number, number][] = [
  //   [55.751574, 37.573856], // МКАД, съезд 45 (точка A)
  //   [55.594471, 37.111384], // Садовая улица Крёкшино (точка B)
  // ];

  return (
    <section className="py-10 font-open-sans px-[33px]">
      <Layout.Container>
        {/* <h3 className="text-3xl font-bold text-center mb-6">
          Инфраструктура Крёкшино
        </h3> */}

        <div className="px-[33px] screen-700:px-0">
          <div className="relative flex">
            {/* Боковое меню с фильтрами */}
            <div
              className={cn(
                'absolute top-0 left-0 bottom-0 h-full z-10 backdrop-blur-[2px] w-full bg-plt-black/50 p-4  shadow-lg transition-all duration-300 screen-850:right-0 screen-850:bottom-[unset] screen-850:h-[341px] ',
                isSidebarOpen
                  ? 'w-full max-w-[370px] screen-850:max-w-full screen-700:h-full landscape:screen-850:h-full'
                  : 'w-12 screen-850:w-full screen-850:h-14'
              )}
            >
              <button
                onClick={() => setIsSidebarOpen(!isSidebarOpen)}
                className="absolute top-1/2 -translate-y-1/2 right-0 text-plt-white hover:opacity-70 mb-4 screen-850:bottom-0 screen-850:top-[unset] screen-850:left-1/2 screen-850:translate-y-0"
              >
                {isSidebarOpen ? (
                  <ChevronLeft className="size-8 screen-850:rotate-90" />
                ) : (
                  <ChevronRight className="size-8 screen-850:rotate-90" />
                )}
              </button>

              {isSidebarOpen && (
                <div className="space-y-2 flex flex-col h-full justify-center px-10">
                  {Object.keys(filterCounts).map(el => {
                    return {
                      key: el,
                      label: filterToCategoryMap[el as keyof FilterCounts],
                      length: filterCounts[el as keyof FilterCounts]
                    }
                  })
                    .map((filter) => (
                      <div
                        key={filter.key}
                        className="flex gap-2 justify-between items-center"
                      >
                        <div className="flex gap-2 items-center">
                          <Checkbox
                            id={`maps-filter-check-${filter.key}`}
                            checked={filters[filter.key as keyof Filters]}
                            onCheckedChange={() =>
                              handleFilterChange(filter.key as keyof Filters)
                            }
                            className="border-plt-white text-plt-white"
                          />
                          <label
                            htmlFor={filter.key}
                            className="text-sm text-plt-white font-semibold cursor-pointer"
                          >
                            {filter.label}
                          </label>
                        </div>
                        <span className="text-plt-white font-semibold">
                          {filter.length}
                        </span>
                      </div>
                    ))}
                </div>
              )}
            </div>

            {/* Карта */}
            <div className="flex-1 w-full" >
              <YMaps query={{ apikey: 'ВАШ_API_КЛЮЧ' }}>
                <Map
                  defaultState={{
                    center: [55.595800, 37.104352], // Центр Крёкшино
                    zoom: 15,
                  }}
                  className="h-[600px] screen-850:h-[733px]"
                >
                  {/* Маршрут */}
                  {/* <GeoObject
                  geometry={{
                    type: 'LineString',
                    coordinates: routePoints,
                  }}
                  options={{
                    strokeColor: '#0000FF', // Синий цвет линии
                    strokeWidth: 5,
                    strokeStyle: 'solid',
                  }}
                /> */}

                  {/* Метки маршрута */}
                  {/* <Placemark
                  geometry={routePoints[0]}
                  properties={{
                    hintContent: 'МКАД, съезд 45',
                    balloonContent: 'МКАД, съезд 45',
                  }}
                  options={{
                    preset: 'islands#redDotIcon',
                  }}
                />
                <Placemark
                  geometry={routePoints[1]}
                  properties={{
                    hintContent: 'Садовая улица Крёкшино',
                    balloonContent: 'Садовая улица Крёкшино',
                  }}
                  options={{
                    preset: 'islands#blueDotIcon',
                  }}
                /> */}

                  {/* Точки инфраструктуры */}
                  {filteredLocations.map((location) => (
                    <Placemark
                      key={location.id}
                      geometry={location.coordinates}
                      properties={{
                        hintContent: location.title,
                        balloonContent: `
                        <div>
                          <strong>${location.title}</strong><br/>
                          Расстояние: ${location.distance}<br/>
                          Время: ${location.time}
                        </div>
                      `,
                      }}
                      options={{
                        preset: 'islands#blueDotIcon',
                        balloonCloseButton: true,
                      }}
                    />
                  ))}
                  {/* ЖК Крекшино */}
                  <Placemark
                    key={'Крекшино'}
                    geometry={[55.594697, 37.108854]}
                    options={{
                      iconLayout: 'default#image',
                      iconImageSize: [54, 59],
                      iconImageOffset: [-20, -49],
                      iconImageHref: 'assets/images/krekshino.svg',
                      balloonCloseButton: true,
                    }}
                  />
                </Map>
              </YMaps>
            </div>
          </div>
        </div>
      </Layout.Container>
    </section>
  );
};

export default YandexMapWithFilters;
